import React from 'react';
import { Search } from 'lucide-react';

export const DataTable = ({ columns, data, searchable = false, emptyMessage = 'No data available' }) => {
  const [searchTerm, setSearchTerm] = React.useState('');

  const filteredData = React.useMemo(() => {
    if (!searchable || !searchTerm) return data;
    
    return data.filter(row =>
      Object.values(row).some(value =>
        String(value).toLowerCase().includes(searchTerm.toLowerCase())
      )
    );
  }, [data, searchTerm, searchable]);

  return (
    <div className="table-container">
      {searchable && (
        <div className="search-bar">
          <Search className="search-icon" />
          <input
            type="text"
            placeholder="Search..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="search-input"
            data-testid="table-search-input"
          />
        </div>
      )}
      
      <div className="table-wrapper">
        <table className="data-table">
          <thead>
            <tr>
              {columns.map((col, idx) => (
                <th key={idx} data-testid={`table-header-${col.key}`}>{col.label}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {filteredData.length === 0 ? (
              <tr>
                <td colSpan={columns.length} className="empty-state" data-testid="table-empty-state">
                  {emptyMessage}
                </td>
              </tr>
            ) : (
              filteredData.map((row, rowIdx) => (
                <tr key={rowIdx} data-testid={`table-row-${rowIdx}`}>
                  {columns.map((col, colIdx) => (
                    <td key={colIdx} data-testid={`table-cell-${col.key}-${rowIdx}`}>
                      {col.render ? col.render(row) : row[col.key]}
                    </td>
                  ))}
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};
